// extracted by mini-css-extract-plugin
export var border = "_2b-8";
export var brand = "_2b-t";
export var button = "_2b-l";
export var center = "_2b-a";
export var centered = "_2b-6";
export var closeButton = "_2b-c";
export var disabledWrapper = "_2b-m";
export var error = "_2b-p";
export var extraLarge = "_2b-4";
export var extraSmall = "_2b-1";
export var fill = "_2b-i";
export var footer = "_2b-h";
export var footerAction = "_2b-j";
export var footerButtons = "_2b-k";
export var header = "_2b-7";
export var headerWithClose = "_2b-d";
export var icon = "_2b-o";
export var info = "_2b-s";
export var inline = "_2b-9";
export var large = "_2b-3";
export var main = "_2b-e";
export var modal = "_2b-0";
export var nearFull = "_2b-5";
export var neutral = "_2b-u";
export var noPadding = "_2b-g";
export var none = "_2b-v";
export var scrollable = "_2b-f";
export var small = "_2b-2";
export var success = "_2b-r";
export var tight = "_2b-n";
export var titleIcon = "_2b-b";
export var warn = "_2b-q";